// extracted by mini-css-extract-plugin
export default {"routes":"Routes_routes__uiuBy","nav":"Routes_nav__xDzHl","content":"Routes_content__JBgJH"};